// Shared design tokens for the combined Report page. Keeps all four tabs
// visually consistent instead of each inheriting its own source page's look.
// Status/categorical hues are the validated defaults from the dataviz skill
// (CVD-safe ordering) rather than ad-hoc picks; surfaces/accent match the
// app's existing dark theme and brand pink so the page still feels native.

export const REPORT_COLORS = {
  cardBg: "#1A1B24",
  cardBorder: "rgba(255,255,255,0.08)",
  cardBgRaised: "#212230",
  textPrimary: "#FFFFFF",
  textSecondary: "#9CA3AF",
  textMuted: "#6B7280",
  accent: "#F6255A",
  accentSoft: "rgba(246,37,90,0.12)",

  // Status — matches the emerald/amber/red already used everywhere else in
  // this app (Forecasting, AI Reports, AppScanner), not a generic reference
  // palette, so the Report page's colors feel native rather than foreign.
  // Icon + label still always pairs with these, never color alone.
  good: "#10b981",
  goodSoft: "rgba(16,185,129,0.12)",
  warning: "#f59e0b",
  warningSoft: "rgba(245,158,11,0.12)",
  serious: "#f97316",
  seriousSoft: "rgba(249,115,22,0.12)",
  critical: "#ef4444",
  criticalSoft: "rgba(239,68,68,0.12)",

  // Fixed-order categorical hues (dark-mode steps) — assign by slot index, never cycle arbitrarily
  categorical: ["#3987e5", "#d95926", "#199e70", "#c98500", "#d55181", "#008300", "#9085e9", "#e66767"],

  // Sequential (single-hue) ramp for magnitude — used by the forecast chart
  sequential: {
    100: "#cde2fb",
    250: "#86b6ef",
    400: "#3987e5",
    500: "#256abf",
    600: "#184f95",
  },
}

export const REPORT_RADIUS = 20
export const REPORT_SPACING = { xs: 8, sm: 12, md: 16, lg: 24, xl: 32 }
